module.exports = __webpack_public_path__ + "static/media/brackets-curly.0eab72d5.svg";